<template>
  <div class="pc-track">
    <h1 class="pc-track-head">用户轨迹</h1>

    <div class="pc-track-line" v-show="textShow == false">
      <el-steps finish-status="success" align-center>
        <el-step
          v-for="(item, index) in data"
          :key="index"
          :title="$dtime(data[index].track.pages[0].time).format('YYYY.MM.DD')"
          :class="{ active: currentIndex == index }"
          @click.native="changeSelect(index)"
        >
        </el-step>
      </el-steps>
    </div>
    <div v-show="textShow" class="pc-hintText">{{ hintText }}</div>

    <div class="pc-track-table">
      <table
        widuser="100%"
        height="120px"
        border="1px"
        bordercolor="#DDDDDD"
        align="center"
        cellspacing="0"
      >
        <tr>
          <td>地域</td>
          <td>{{ table.region ? table.region : "- -" }}</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>设备</td>
          <td>{{ table.device ? table.device : "- -" }}</td>
          <td>访问次数</td>
          <td>{{ table.browseTimes ? table.browseTimes : "- -" }}</td>
        </tr>
        <tr>
          <td>时长</td>
          <td>{{ table.activeTime ? table.activeTime : "- -" }}</td>
          <td>浏览页面</td>
          <td>{{ table.browsePage ? table.browsePage : "- -" }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>



<script>

export default {
  props: ["data"],
  watch: {
    data: function () {
      this.dealWithData();
    },
  },
  data() {
    return {
      currentIndex: 0,
      hintText: "数据暂未入库",
      textShow: false,
      table: {
        region: null,
        from: null,
        device: null,
        browseTimes: null,
        activeTime: null,
        browsePage: null,
      },
    };
  },
  methods: {
    
    dealWithData() {
      console.log("chakna", this.data, this.currentIndex);
      if (this.data[this.currentIndex]) {
        let _atr = this.data[this.currentIndex].attribute;
        // 加工地域
        this.table.region = (
          !_atr.accessArea[0].city
            ? false
            : !_atr.accessArea[0].region
            ? false
            : _atr.accessArea[0].ip
            ? true
            : false
        )
          ? _atr.accessArea[0].city +
            " - " +
            _atr.accessArea[0].region +
            " (" +
            _atr.accessArea[0].ip +
            ")"
          : null;
        // 加工来源
        // this.table.from = '不做了砍掉了';
        // 加工设备
        this.table.device =
          (_atr.usedDevice.iPhone > 0 ? "苹果手机" : "") +
          (_atr.usedDevice.PC > 0
            ? (_atr.usedDevice.iPhone > 0 ? "; " : "") + "PC"
            : "") +
          (_atr.usedDevice.Android > 0 ? "安卓手机" : "");
        // 加工访问次数
        this.table.browseTimes = this.data[this.currentIndex].track.visitsCount;
        // 加工时长
        this.table.activeTime = this.getDuration(_atr.activeTime / 1000);
        // 加工浏览页面
        this.table.browsePage = this.data[this.currentIndex].track.visitsNumber;

        console.log("111", this.data);
      } else {
        this.textShow = true;
      }
    },

    getDuration(second) {
      var hours = Math.floor(second / 3600) + "";
      var minutes = Math.floor(((second % 86400) % 3600) / 60) + "";
      var seconds = Math.floor(((second % 86400) % 3600) % 60) + "";
      var duration =
        (hours.length == 1 ? "0" : "") +
        hours +
        " : " +
        (minutes.length == 1 ? "0" : "") +
        minutes +
        " : " +
        (seconds.length == 1 ? "0" : "") +
        seconds;
      return duration;
    },

    changeSelect(val) {
      this.currentIndex = val;
      this.dealWithData();
    },
  },
};
</script>



<style lang="scss" scoped>
.pc-track {
  overflow-x: auto;
  padding: 30px 30px 0 30px;
  height: 440px;
  border-radius: 4px;
  box-shadow: $shadowCard;
  .pc-track-head {
    padding-bottom: 15px;
    border-bottom: 1px solid $border-color;
    margin-bottom: 51px;
    font-family: $chinese;
    font-size: 20px;
    font-weight: 600;
    color: $mainTitle;
  }
  .pc-hintText {
    text-align: center;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 20px;
  }
  // 轨迹条
  .pc-track-line::-webkit-scrollbar-thumb {
    background-clip: content-box !important;
    border: 4px solid transparent;
    border-radius: 100px;
    background-color: $lightenGreya;
  }
  .pc-track-line::-webkit-scrollbar-button {
    display: none;
  }
  .pc-track-line::-webkit-scrollbar {
    height: 18px;
    background-color: $lightGreya;
    border-top: 1px solid $indexHotLine;
    border-bottom: 1px solid $indexHotLine;
  }
  .pc-track-line {
    transform: rotateX(180deg);
    margin: 0 60px;
    overflow-x: scroll;
    overflow-y: hidden;
    min-height: 80px;
    .active {
      /deep/ .el-step__title {
        color: $visitorVolumeSmall;
        font-weight: bold;
      }
      /deep/ .el-step__icon {
        background: $visitorVolumeSmall;
        transform: scale(1.6);
      }
    }

    /deep/ .el-step {
      min-width: 107px;
    }
    /deep/ .el-step__icon-inner {
      display: none !important;
    }
    /deep/ .el-step__icon {
      margin-top: 5.5px;
      width: 13px;
      height: 13px;
      border: 2px solid white;
      background: $blueBtna;
      cursor: pointer;
    }
    /deep/ .el-step__icon:hover {
      background: $visitorVolumeSmall !important;
      transform: scale(1.3);
    }
    /deep/ .el-step__line-inner {
      border-color: #c0c4cc !important;
    }
    /deep/ .el-step__title {
      font-family: $chinese;
      font-size: 14px;
      font-weight: 400;
      color: $mainTitle;
      white-space: nowrap;
      transform: translateY(-25px) rotateX(180deg);
    }
    /deep/ .el-step__head {
      transform: translateY(30px);
    }
  }
  // end 轨迹条

  .pc-track-table {
    margin-top: 50px;
    padding: 0 60px;
    table {
      width: 100%;
      td {
        font-family: $chinese;
        font-size: 14px;
        font-weight: 400;
        color: $mainTitle;
        text-align: center;
      }
      tr td:nth-of-type(1),
      tr td:nth-of-type(3) {
        background-color: #f7f7f7;
        text-align: right;
        padding-right: 21px;
        width: 17%;
      }
      tr td:nth-of-type(2),
      tr td:nth-of-type(4) {
        text-align: left;
        padding-left: 21px;
        width: 33%;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/userManagement/userDetail/UserTrack.vue